import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import theme from '../styles/theme';
import { formatCurrency, formatCompactNumber } from '../utils/financial-calculations';

const PatrimonyChart = ({ data }) => {
  return (
    <div className="h-64 md:h-96 p-4 rounded-lg border" style={{ borderColor: theme.colors.azul }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={{ top: 10, right: 30, left: 20, bottom: 30 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
          <XAxis 
            dataKey="age" 
            label={{ value: 'Idade', position: 'bottom', offset: 0 }}
            stroke={theme.colors.azul}
          />
          <YAxis 
            tickFormatter={formatCompactNumber}
            label={{ value: 'Patrimônio (R$)', angle: -90, position: 'insideLeft' }}
            stroke={theme.colors.azul}
          />
          <Tooltip 
            formatter={(value) => [formatCurrency(value), 'Patrimônio']}
            labelFormatter={(value) => `Idade: ${value} anos`}
            contentStyle={{ backgroundColor: theme.colors.offwhite, borderColor: theme.colors.azul }}
          />
          <Line 
            type="monotone" 
            dataKey="patrimony" 
            stroke={theme.colors.azul} 
            strokeWidth={3} 
            dot={{ r: 4, stroke: theme.colors.azul, fill: theme.colors.amarelo }}
            activeDot={{ r: 8, stroke: theme.colors.azul, fill: theme.colors.amarelo }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PatrimonyChart;
